import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { TypeSortie } from "app/models/type-sortie";

@Injectable()
export class TypeSortieService {
  private url = `/api/type/sortie`;
  constructor(private http: HttpClient) { }


  public find(): Observable<[TypeSortie]> {
    const params = new HttpParams()
      .set('size', 'page')
      .set('size', '50')
      .set('sortName', 'id')
      .set('sortType', 'DESC');
     return this.http.get<[TypeSortie]>(this.url, { params: params });
   }

   create(item: TypeSortie) {
     return this.http.post(this.url, item)
       .map(
         (data) => {
           console.log(data);
         }
       );
   }

   delete(item: TypeSortie) {
     return this.http.delete(`${this.url}/${item.id}`)
       .map(
         (data) => {
           console.log(data);
         }
       );
   }
   update(item: TypeSortie) {
     return this.http.put(`${this.url}/${item.id}`, item)
       .map(
         (data) => {
           console.log(data);
         }
       );
   }
 }



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/type-sortie.service.ts